import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Nav = () => {
  const [visits, setVisits] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/visits`)
      .then((res) => setVisits(res.data.count))
      .catch(() => setVisits(null));
  }, []);

  const go = (id) => document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 border-b border-[#DCDCD6] bg-[#F4F4F0]/80 backdrop-blur-md"
      data-testid="site-nav"
    >
      <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-center gap-2 px-4 py-3 md:gap-4 md:px-6 md:py-4">
        <button
          onClick={() => go("#contact")}
          data-testid="nav-cta-button"
          className="border border-[#111111] bg-[#DCDCD6] px-3 py-2 text-[10px] font-semibold uppercase tracking-[0.2em] text-[#111111] transition-colors duration-300 hover:bg-[#111111] hover:text-[#F4F4F0] md:px-5 md:py-2.5 md:text-xs"
        >
          GET IN TOUCH
        </button>
        <a
          href="https://www.cityofkingston.ca/council-and-city-administration/elections/voters/"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="nav-vote-button"
          className="border border-[#111111] bg-[#DCDCD6] px-3 py-2 text-[10px] font-semibold uppercase tracking-[0.2em] text-[#111111] transition-colors duration-300 hover:bg-[#111111] hover:text-[#F4F4F0] md:px-5 md:py-2.5 md:text-xs"
        >
          How to Vote
        </a>
        <button
          onClick={() => go("#acm")}
          data-testid="nav-acm-qa-button"
          className="border border-[#111111] bg-[#DCDCD6] px-3 py-2 text-[10px] font-semibold uppercase tracking-[0.2em] text-[#111111] transition-colors duration-300 hover:bg-[#111111] hover:text-[#F4F4F0] md:px-5 md:py-2.5 md:text-xs"
        >
          District #3 ACM Q&amp;A
        </button>
        {visits !== null && (
          <span
            className="border border-[#111111] bg-[#DCDCD6] px-3 py-2 text-[10px] font-semibold uppercase tracking-[0.2em] text-[#111111] md:px-5 md:py-2.5 md:text-xs"
            data-testid="visit-counter"
          >
            Total visits: {visits.toLocaleString()}
          </span>
        )}
      </div>
    </header>
  );
};
